module.exports = __webpack_public_path__ + "static/media/chejianshengchai61.2810c60c.png";